import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import {
  Observable, combineLatest, from
} from 'rxjs';
import { concatMap, catchError } from 'rxjs/operators';

import { Branch } from 'graphql/models/generated';
import { SessionService } from 'shared/services/session.service';
import { StoreService } from 'shared/services/store.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  activeBranchId = '';

  constructor(
    private storeService: StoreService,
    private keycloakService: KeycloakService,
    private sessionService: SessionService
  ) {
    combineLatest([
      this.storeService.isCurrentAccountDealer(),
      this.storeService.getCurrentAccountBranch()
    ]).subscribe(([isDealer, branch]: [boolean, Branch]) => {
      this.activeBranchId = isDealer && branch && branch.id ? branch.id : '';
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const r = req.clone({
      withCredentials: false,
      headers: this.activeBranchId ? req.headers.set('x-arbhs-active-branch', this.activeBranchId) : req.headers
    });

    return from(this.keycloakService.updateToken(60))
      .pipe(
        catchError(() => this.sessionService.logout()),
        concatMap(() => next.handle(r))
      );
  }
}
